// Granular sync-day status taxonomy. Order matters:
// - STATUSES is the legend order (worst → best, then no_data).
// - PRIORITY is the worst-first ranking used when aggregating multiple centers
//   onto a single calendar cell.
export const STATUSES = [
  'failed',
  'upload_failed',
  'pending',
  'processing',
  'waiting_archive',
  'duplicate',
  'processed',
  'no_data',
];

export const PRIORITY = STATUSES.slice(0, -1).concat(['no_data']);

export const LABEL_KEYS = {
  failed:           'statusFailed',
  upload_failed:    'statusUploadFailed',
  pending:          'statusPending',
  processing:       'statusProcessing',
  waiting_archive:  'statusWaitingArchive',
  duplicate:        'statusDuplicate',
  processed:        'statusProcessed',
  no_data:          'statusNoData',
};
